(function () {
  'use strict';

  const discountCodes = {
    RTR3MLS2: {
      message: 'Lege das passende Gratis-Produkt in den Warenkorb. Der Code gilt einmal pro Kunde, ohne Mindestbestellwert.'
    },
    '6R9MVX': {
      message: 'Lege das passende Gratis-Produkt in den Warenkorb. Der Code gilt einmal pro Kunde, ohne Mindestbestellwert.'
    },
    XKZC4: {
      message: 'Lege das passende Gratis-Produkt in den Warenkorb. Der Code gilt einmal pro Kunde, ohne Mindestbestellwert.'
    },
    FS7TXN: {
      message: 'Lege das passende Gratis-Produkt in den Warenkorb. Der Code gilt einmal pro Kunde, ohne Mindestbestellwert.'
    }
  };

  const genericError = 'Der Rabattcode, den Sie eingegeben haben, ist ungültig oder kann nicht auf diesen Warenkorb angewendet werden';
  let lastEnteredCode = '';
  let discountEnhanceQueued = false;
  let dingDoongCompactQueued = false;
  let tierProgressQueued = false;

  function getCurrentDiscountCode() {
    const input = document.querySelector('.kaching-cart__discount-code-input')
      || document.querySelector('[class*="kaching-cart"] input[name="discount"]')
      || document.querySelector('input[placeholder="Discount code"]')
      || document.querySelector('input[name="discount"]');

    if (input && input.value) {
      return input.value.toUpperCase().trim();
    }

    return lastEnteredCode;
  }

  function findErrorElements() {
    const containers = document.querySelectorAll('.kaching-cart__discount-code-errors, [class*="kaching-cart__discount-code-errors"]');
    const results = [];

    containers.forEach((container) => {
      const paragraphs = container.querySelectorAll('p');

      paragraphs.forEach((paragraph) => {
        if (paragraph.textContent && paragraph.textContent.includes(genericError)) {
          results.push(paragraph);
        }
      });

      if (paragraphs.length === 0 && container.textContent && container.textContent.includes(genericError)) {
        results.push(container);
      }
    });

    return results;
  }

  function replaceErrorText() {
    const code = getCurrentDiscountCode();
    const config = discountCodes[code];

    if (!config) return;

    findErrorElements().forEach((element) => {
      element.textContent = config.message;
    });
  }

  function trackDiscountInput(event) {
    const target = event.target;
    if (!target || target.tagName !== 'INPUT') return;

    const placeholder = target.getAttribute('placeholder') || '';
    const name = target.getAttribute('name') || '';
    const isDiscountInput = target.classList.contains('kaching-cart__discount-code-input')
      || target.matches('[class*="kaching-cart"] input')
      || placeholder.toLowerCase().includes('discount')
      || name.toLowerCase().includes('discount');

    if (isDiscountInput) {
      lastEnteredCode = target.value.toUpperCase().trim();
    }
  }

  function findDiscountPanels() {
    const selectors = [
      '.kaching-cart__discount-code',
      '.kaching-cart__discount-code-form',
      '[class*="kaching-cart__discount-code"]',
      '[class*="kaching-cart__discount-code-form"]'
    ];
    const selector = selectors.join(',');

    return Array.from(document.querySelectorAll(selector)).filter((panel) => {
      const parentPanel = panel.parentElement && panel.parentElement.closest(selector);
      if (parentPanel) return false;

      return panel.querySelector('input')
        || panel.querySelector('[class*="discount-code-input"]')
        || panel.textContent.toLowerCase().includes('rabatt')
        || panel.textContent.toLowerCase().includes('discount');
    });
  }

  function getDiscountToggle(panel) {
    return panel.querySelector('[data-kaching-discount-toggle]');
  }

  function setDiscountToggleState(toggle, isOpen) {
    if (!toggle) return;

    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    const icon = toggle.querySelector('[aria-hidden="true"]');
    if (icon) {
      icon.textContent = isOpen ? '-' : '+';
    }
  }

  function enhanceDiscountPanels() {
    discountEnhanceQueued = false;

    findDiscountPanels().forEach((panel) => {
      panel.classList.add('r-kaching-discount-panel');

      const input = panel.querySelector('input');
      const hasValue = input && input.value && input.value.trim();
      const errorElement = panel.querySelector('.kaching-cart__discount-code-errors, [class*="kaching-cart__discount-code-errors"]');
      const hasError = errorElement && errorElement.textContent.trim();

      if (hasValue || hasError) {
        panel.classList.add('is-open');
      }

      if (getDiscountToggle(panel)) return;

      const isOpen = panel.classList.contains('is-open');
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'r-kaching-discount-toggle';
      toggle.setAttribute('data-kaching-discount-toggle', '');
      toggle.innerHTML = `<span>Rabattcode</span><span aria-hidden="true">${isOpen ? '-' : '+'}</span>`;
      setDiscountToggleState(toggle, isOpen);

      toggle.addEventListener('click', () => {
        const nextIsOpen = panel.classList.toggle('is-open');
        setDiscountToggleState(toggle, nextIsOpen);

        if (nextIsOpen && input) {
          window.setTimeout(() => input.focus(), 40);
        }
      });

      panel.insertBefore(toggle, panel.firstElementChild);
    });
  }

  function scheduleDiscountEnhancement() {
    if (discountEnhanceQueued) return;
    discountEnhanceQueued = true;
    window.requestAnimationFrame(enhanceDiscountPanels);
  }

  function isDingDoongWrapper(element) {
    if (!element || !element.className || !element.style) return false;

    const tagName = element.tagName || '';
    if (/^(BUTTON|INPUT|SELECT|TEXTAREA|SVG|PATH)$/i.test(tagName)) return false;

    const className = element.className.toString().toLowerCase();
    if (!className.includes('dingdoong') && !className.includes('delivery-date')) return false;

    const isPopoverShell = className.includes('calendar__popover')
      && !className.includes('calendar__popover-button')
      && !className.includes('calendar__popover-content');

    const protectedParts = [
      'calendar__day',
      'calendar__grid',
      'calendar__header',
      'calendar__month',
      'calendar__navigation',
      'calendar__popover-button',
      'calendar__popover-content',
      'calendar__weekday',
      'dropdown__button',
      'dropdown__content',
      'modal',
      'button',
      'icon',
      'value',
      'message',
      'title',
      'label',
      'required',
      'error',
      'caption',
      'selected',
      'disabled'
    ];

    if (!isPopoverShell && protectedParts.some((part) => className.includes(part))) return false;

    const wrapperParts = [
      'ot-dingdoong-root',
      'ot-dingdoong-main',
      'ot-dingdoong-header',
      'ot-dingdoong-calendar__popover',
      'ot-dingdoong-day-picker-container',
      'ot-dingdoong-dropdown',
      'ot-delivery-date',
      'ot-delivery-date_date-input',
      'ot-delivery-date_date-input-container',
      'ot-delivery-date_date-input-wrapper',
      'ot-delivery-date_date-input-date'
    ];

    return wrapperParts.some((part) => className.includes(part));
  }

  function stripDingDoongWrapperStyles(element) {
    element.style.setProperty('background', 'transparent', 'important');
    element.style.setProperty('border', '0', 'important');
    element.style.setProperty('box-shadow', 'none', 'important');
    element.style.setProperty('margin', '0', 'important');
    element.style.setProperty('outline', '0', 'important');
    element.style.setProperty('padding', '0', 'important');
    element.style.setProperty('max-width', '100%', 'important');
  }

  function compactDingDoong() {
    dingDoongCompactQueued = false;

    const roots = document.querySelectorAll([
      '.kaching-cart .ot-dingdoong-root',
      '.kaching-cart .ot-dingdoong-root-cart-drawer',
      '.kaching-cart .ot-dingdoong-root-cart-drawer-custom',
      '[class*="kaching-cart"] .ot-dingdoong-root',
      '[class*="kaching-cart"] .ot-dingdoong-root-cart-drawer',
      '[class*="kaching-cart"] .ot-dingdoong-root-cart-drawer-custom',
      '.ot-dingdoong-root-cart-drawer',
      '.ot-dingdoong-root-cart-drawer-custom',
      '.dingdoong-embed-root .ot-dingdoong-root',
      '[class*="kaching-cart"] [class*="delivery-date"]',
      '.kaching-cart [class*="delivery-date"]'
    ].join(','));

    roots.forEach((root) => {
      root.classList.add('r-dingdoong-tight');
      if (isDingDoongWrapper(root)) stripDingDoongWrapperStyles(root);

      root.querySelectorAll('[class*="dingdoong"], [class*="delivery-date"]').forEach((element) => {
        if (isDingDoongWrapper(element)) {
          stripDingDoongWrapperStyles(element);
        }
      });

      root.querySelectorAll([
        '.ot-dingdoong-time-picker-container',
        '[class*="time-picker"]',
        '[class*="time-slot"]'
      ].join(',')).forEach((element) => {
        element.style.setProperty('display', 'none', 'important');
      });
    });
  }

  function scheduleDingDoongCompact() {
    if (dingDoongCompactQueued) return;
    dingDoongCompactQueued = true;
    window.requestAnimationFrame(compactDingDoong);
  }

  function getTierProgressLabel(icon) {
    const title = icon.querySelector('.kaching-cart__tiered-promotions-bar-icon-tooltip-title');
    const text = title && title.textContent ? title.textContent : icon.textContent;

    return text ? text.replace(/\s+/g, ' ').trim() : '';
  }

  function enhanceTierProgressLabels() {
    tierProgressQueued = false;

    document.querySelectorAll('.kaching-cart__tiered-promotions-bar').forEach((bar) => {
      const progressContainer = bar.querySelector('.kaching-cart__tiered-promotions-bar-progress-container');
      const icons = Array.from(bar.querySelectorAll('.kaching-cart__tiered-promotions-bar-icon'));
      const labels = icons.map(getTierProgressLabel).filter(Boolean);

      if (!progressContainer || labels.length < 2) return;

      const labelKey = labels.join('|');
      let labelsRow = bar.querySelector('.r-kaching-progress-labels');

      bar.classList.add('r-kaching-progress-spaced');

      if (!labelsRow) {
        labelsRow = document.createElement('div');
        labelsRow.className = 'r-kaching-progress-labels';
        progressContainer.insertAdjacentElement('afterend', labelsRow);
      }

      labelsRow.style.setProperty('--r-progress-label-count', labels.length);

      if (labelsRow.getAttribute('data-r-labels') === labelKey) return;

      labelsRow.setAttribute('data-r-labels', labelKey);
      labelsRow.replaceChildren(...labels.map((label) => {
        const item = document.createElement('span');
        item.textContent = label;
        return item;
      }));
    });
  }

  function scheduleTierProgressLabels() {
    if (tierProgressQueued) return;
    tierProgressQueued = true;
    window.requestAnimationFrame(enhanceTierProgressLabels);
  }

  function scheduleAppEnhancements() {
    scheduleDiscountEnhancement();
    scheduleDingDoongCompact();
    scheduleTierProgressLabels();
  }

  function init() {
    document.addEventListener('input', trackDiscountInput, true);
    document.addEventListener('focusin', (event) => {
      const panel = event.target && event.target.closest && event.target.closest('.r-kaching-discount-panel');
      if (!panel) return;

      panel.classList.add('is-open');
      setDiscountToggleState(getDiscountToggle(panel), true);
    }, true);

    document.addEventListener('click', scheduleDingDoongCompact, true);
    document.addEventListener('focusin', scheduleDingDoongCompact, true);

    scheduleAppEnhancements();
    [120, 420, 900, 1800].forEach((delay) => {
      window.setTimeout(scheduleAppEnhancements, delay);
    });

    new MutationObserver(scheduleAppEnhancements).observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setInterval(replaceErrorText, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
